module.exports = __webpack_public_path__ + "img/hr-tree-03-c-leaves.f6e81eaa.png";